import { useIntl, defineMessages } from 'react-intl';
import type { StaticImageData } from 'next/image';
import styles from './styles.module.scss';

export type SocialCard = {
  handle: string;
  images: {
    avif: StaticImageData;
    jpg: StaticImageData;
    webp: StaticImageData;
  };
};

const messages = defineMessages({
  altText: {
    defaultMessage: 'AllTrails users hitting the trails and finding their way outside'
  }
});

const SocialCard = ({ images, handle }: SocialCard) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <picture>
          <source srcSet={images.avif.src} type="image/avif" />
          <source srcSet={images.webp.src} type="image/webp" />
          <img className={styles.image} loading="lazy" src={images.jpg.src} alt={intl.formatMessage(messages.altText)} />
        </picture>
      </div>
      <div className={styles.handle}>{handle}</div>
    </div>
  );
};

export default SocialCard;
